import { useState } from 'react'

import { Col, Collapse, CollapseProps, Drawer, Row } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { BidMemberListApplyPanel } from './ApplyPanel'
import { ApplyRefreshButton } from './components/RefreshButton'
import { BidMemberListModalStoreProvider } from './Store'
import { BidMemberListUserPanel } from './UserPanel'

const PANEL_KEYS = ['userPanel', 'applyPanel']

export const BidMemberListModal = () => {
  const {
    currentAuction,
    bidMemberListModalVisible,
    toggleBidMemberListModalVisible
  } = useAuctionListStore(state =>
    pick(state, [
      'currentAuction',
      'toggleBidMemberListModalVisible',
      'bidMemberListModalVisible'
    ])
  )

  const [activeKeys, setActiveKeys] = useState(PANEL_KEYS)

  const showUserPanel =
    currentAuction?.status === AuctionOperationPageStatus.WAIT_START

  const items: CollapseProps['items'] = [
    {
      key: PANEL_KEYS[0],
      label: '待邀约',
      children: <BidMemberListUserPanel />
    },
    {
      key: PANEL_KEYS[1],
      label: (
        <Row align='top' justify='space-between'>
          <Col>已邀约</Col>
          <Col>
            <ApplyRefreshButton />
          </Col>
        </Row>
      ),
      children: <BidMemberListApplyPanel />
    }
  ]

  const body = showUserPanel ? (
    <Collapse
      ghost
      accordion={false}
      activeKey={activeKeys}
      bordered={false}
      items={items}
      onChange={keys => {
        // 禁止收起邀约记录面板
        setActiveKeys([...new Set([PANEL_KEYS[1], ...keys])])
      }}
    />
  ) : (
    <BidMemberListApplyPanel />
  )

  const closeModal = () => {
    toggleBidMemberListModalVisible(false)
  }

  const title = `${currentAuction?.title} — 会员列表`

  return (
    <Drawer
      open={bidMemberListModalVisible}
      title={title}
      styles={{
        wrapper: {
          width: '90%'
        },
        body: showUserPanel
          ? {
              paddingBlock: 0
            }
          : undefined
      }}
      onClose={closeModal}
    >
      <BidMemberListModalStoreProvider>{body}</BidMemberListModalStoreProvider>
    </Drawer>
  )
}
